const translations = {
  "en": {
    "Couldn't update. Please try again.": "Couldn't update. Please try again.",
    "Please review the terms and try again.": "Please review the terms and try again.",
    "Session expired. Please try again.": "Session expired. Please try again.",
    "This action isn't available for this subscription.": "This action isn't available for this subscription."
  },
  "zh-tw": {
    "Couldn't update. Please try again.": "無法更新。請再試一次。",
    "Please review the terms and try again.": "請檢視條款並重試。",
    "Session expired. Please try again.": "工作階段已過期。請再試一次。",
    "This action isn't available for this subscription.": "此操作不適用於此訂閱。"
  }
};

export default translations;
